import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["searchContainerActive", "className", "placeholder", "value", "onChange", "onSearch", "isClearable"],
  _excluded2 = ["label", "input", "placeholder"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { RootCloseWrapper } from 'react-overlays';
import _noop from 'lodash/noop';
import _debounce from 'lodash/debounce';
import { EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import ActionButton from '../../molecules/ActionButton';
import TextInput from '../../atoms/Input';
import PropertyControlledComponent from '../../molecules/PropertyControlledComponent';
import ExpandableSearchUtils from './ExpandableSearch.utils';
import styles from './expandableSearch.module.scss';
var ENTER_KEY_CODE = 13;
var ExpandableSearch = /*#__PURE__*/function (_React$Component) {
  _inherits(ExpandableSearch, _React$Component);
  var _super = _createSuper(ExpandableSearch);
  function ExpandableSearch() {
    var _this;
    _classCallCheck(this, ExpandableSearch);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isActive: false
    });
    _defineProperty(_assertThisInitialized(_this), "updateValue", _debounce(function (value) {
      var onChange = _this.props.onChange;
      onChange(value);
    }, 400));
    _defineProperty(_assertThisInitialized(_this), "_input", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "resetInputValue", function () {
      var value = _this.props.value;
      _this.setState({
        inputValue: value
      });
    });
    _defineProperty(_assertThisInitialized(_this), "updateInputValue", function () {
      var value = _this.props.value;
      _this.setState({
        inputValue: value
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onKeyUp", function (event) {
      var value = event.target.value;
      var onSearch = _this.props.onSearch;
      if (event.keyCode === ENTER_KEY_CODE && value) {
        _this.lastSearchValue = value;
        onSearch(value);
        _this._input.current.input.blur();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      var onSearch = _this.props.onSearch;
      var searchValue = e.target.value;
      if (searchValue === EMPTY_STRING && _this.lastSearchValue !== EMPTY_STRING) {
        onSearch(searchValue);
      }
      _this.updateValue(searchValue);
      _this.setState({
        inputValue: searchValue
      });
    });
    _defineProperty(_assertThisInitialized(_this), "activate", function () {
      _this.setState({
        isActive: true
      }, function () {
        return _this._input.current.input.focus();
      });
    });
    _defineProperty(_assertThisInitialized(_this), "deactivate", function () {
      var _this$state = _this.state,
        isActive = _this$state.isActive,
        inputValue = _this$state.inputValue;
      if (!inputValue && isActive) {
        _this.setState({
          isActive: false
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "clearValue", function () {
      var _this$props = _this.props,
        onChange = _this$props.onChange,
        onSearch = _this$props.onSearch;
      var inputValue = _this.state.inputValue;
      var hasValue = !!inputValue;
      if (hasValue) {
        _this._input.current.input.focus();
      } else {
        _this._input.current.input.blur();
      }
      _this.setState({
        isActive: hasValue,
        inputValue: EMPTY_STRING
      }, function () {
        onChange(EMPTY_STRING);
        if (_this.lastSearchValue !== EMPTY_STRING) {
          onSearch(EMPTY_STRING);
        }
        _this.lastSearchValue = EMPTY_STRING;
      });
    });
    return _this;
  }
  _createClass(ExpandableSearch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var _this$props2 = this.props,
        value = _this$props2.value,
        isActive = _this$props2.isActive;
      this.setState({
        isActive: isActive
      });
      if (value) {
        this.setState({
          isActive: true,
          inputValue: value
        }, function () {
          return _this2._input.current.input.focus();
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var value = prevProps.value;
      var newValue = this.props.value;
      if (newValue === value) return;
      if (newValue === EMPTY_STRING && newValue !== value) {
        this.resetInputValue();
        return;
      }
      this.updateInputValue();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        searchContainerActive = _this$props3.searchContainerActive,
        className = _this$props3.className,
        placeholder = _this$props3.placeholder,
        value = _this$props3.value,
        onChange = _this$props3.onChange,
        onSearch = _this$props3.onSearch,
        isClearable = _this$props3.isClearable,
        rest = _objectWithoutProperties(_this$props3, _excluded);
      var _this$state2 = this.state,
        isActive = _this$state2.isActive,
        inputValue = _this$state2.inputValue;
      var isSearchIconViewable = ExpandableSearchUtils.isSearchIconViewable(this);
      var isClearIconViewable = ExpandableSearchUtils.isClearIconViewable(this);
      return /*#__PURE__*/React.createElement(RootCloseWrapper, {
        noWrap: true,
        onRootClose: this.deactivate
      }, /*#__PURE__*/React.createElement("div", {
        className: cx(className, styles.expandableInputContainer)
      }, /*#__PURE__*/React.createElement(PropertyControlledComponent, {
        controllerProperty: isSearchIconViewable
      }, /*#__PURE__*/React.createElement(ActionButton, {
        icon: "icon-search",
        color: "black",
        onClick: this.activate,
        disabled: isActive
      })), /*#__PURE__*/React.createElement(TextInput, _extends({
        placeholder: placeholder,
        className: cx(styles.expandableInput, _defineProperty({}, styles.expandableInputActive, isActive), {
          'is-paddingless': !isActive
        }),
        inputWrapperClass: cx({
          'is-borderless': !isActive
        }, _defineProperty({}, styles.expandableInputWrapper, isActive)),
        innerRef: this._input,
        onChange: this.handleChange,
        onKeyUp: this.onKeyUp,
        value: inputValue
      }, rest)), /*#__PURE__*/React.createElement(PropertyControlledComponent, {
        controllerProperty: isClearIconViewable
      }, /*#__PURE__*/React.createElement(ActionButton, {
        icon: "icon-close",
        color: "black",
        className: "mx-1",
        onClick: this.clearValue
        // disabled={!isClearActive}
      }))));
    }
  }]);
  return ExpandableSearch;
}(React.Component);
_defineProperty(ExpandableSearch, "propTypes", {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
  isClearable: PropTypes.bool,
  // eslint-disable-line react/no-unused-prop-types
  className: PropTypes.string,
  placeholder: PropTypes.string,
  searchContainerActive: PropTypes.string,
  isActive: PropTypes.bool
});
_defineProperty(ExpandableSearch, "defaultProps", {
  onSearch: _noop,
  onChange: _noop,
  className: EMPTY_STRING,
  placeholder: "".concat(__('Search'), "..."),
  searchContainerActive: EMPTY_STRING,
  isClearable: true,
  value: EMPTY_STRING,
  isActive: false
});
var renderField = function renderField(_ref) {
  var label = _ref.label,
    input = _ref.input,
    placeholder = _ref.placeholder,
    rest = _objectWithoutProperties(_ref, _excluded2);
  var value = input.value,
    onChange = input.onChange;
  return /*#__PURE__*/React.createElement(ExpandableSearch, _extends({
    value: value,
    onChange: onChange,
    placeholder: placeholder
  }, rest));
};
ExpandableSearch.renderField = renderField;
export default ExpandableSearch;